module.exports = __webpack_public_path__ + "media/images/reminder-icon-62781f178794700564372145ba873a7e4cb314dc27beed26232b18f55c067978.png";